export default __webpack_public_path__ + "static/media/icon-briefcase.4386dc27.svg";